import { toast } from '@buffer-mono/popcorn'

import { draftPermalinkRoute } from '~publish/legacy/routes'

/** Carries only the draft id, so the link survives the draft gaining channels. */
const getDraftShareLink = (contentItemId: string): string =>
  `${window.location.origin}${draftPermalinkRoute.getRoute({ contentItemId })}`

export const copyDraftPermalinkToClipboard = async (
  contentItemId: string,
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(getDraftShareLink(contentItemId))
    // A draft has no channel, so organization membership is the whole gate.
    toast.success('Draft link copied', {
      description: 'Only people in your organization can open it.',
    })
    return true
  } catch {
    toast.error('Unable to copy link')
    return false
  }
}
